export default __webpack_public_path__ + "static/media/hindermovement2.0b54d45c.png";